import React from "react";
import LandingSection from "../components/LandingSection";
import ActionButton from "../utils/ActionButton";
import TabTitle from "../components/TabTitle";
import Footer from "../components/Footer";
import EngineeringFaqSection from "./EngineeringFaqSection";
import DataSources from "../components/DataSources";

const EngineeringAndTechnology = () => {
  return (
    <div>
      <LandingSection
        data={{
          imageName: "Engineering&Technology.webp",
          title: "Professional, Scientific, and Technical Services",
        
        }}
      />
      <div className="verticals_section">
        <div className="verticals-intro">
          <div className="verticals-intro-sec1">
            <h2>Professional, Scientific, and Technical Services</h2>
          </div>
          <div className="verticals-intro-sec2">
            <p>
              The Professional, Scientific, and Technical Services sector
              includes establishments that specialize in performing legal,
              accounting, engineering, architectural, consulting, and scientific
              research services.
            </p>
            
          </div>
        </div>
      </div>
      <TabTitle />
      <EngineeringFaqSection />
      <DataSources
        sources={[
          "https://ledextract.ces.census.gov/qwi/all",
          "https://www.bls.gov/oes/2023/may/oessrci.htm",
        ]}
      />
      <Footer />
    </div>
  );
};

export default EngineeringAndTechnology;
